import { AddressEnumType } from '@src/utilities/types';
import { create } from 'zustand'
import { RegistrationStoreType } from './stores.types';

const setByPath = (obj: any, path: string, value: any) => {
    const keys = path.split('.');
    const lastKey = keys.pop()!;
    const lastObj = keys.reduce((obj, key) => (obj[key] = obj[key] || {}), obj);
    lastObj[lastKey] = value;
    return { ...obj };
};

const useRegistrationStore = create<RegistrationStoreType>((set) => ({
    registration: {
        figure_id: '',
        demand_id: '',
        person_id: '',
        user_role: '',
        partner_informations: {
            is_partner: false,
            brand: {
                name: '',
                code: '',
                slug: '',
                sitecode: ''
            },
            cgp_id: '',
        },
        origin: {
            tracking: '',
            annonce: '',
            format: '',
            support: '',
            term: '',
            referer: ''
        },
        person: {
            basic:{
                civility: '',
                email: '',
                firstname: '',
                lastname: '',
                birthname: '',
                phone: '',
                residence_country: '',
                password: '',
            },
            birth:{
                date: null,
                place:{
                    city: '',
                    country: '',
                    zipcode: ''
                }
            },
            us_person: {
                us_citizen: null,
                us_resident: null,
                has_green_card: null,
                us_taxpayer: null
            },
            family:{
                family_situation: '',
                matrimonial_regime: ''
            },
            legal:{
                legal_capacity: '',
                national_id: '',
                nationality: ''
            },
            professional: {
                activity_domain: '',
                company_name: '',
                job_title: '',
                profession: '',
                professional_situation: '',
                work_in_financial_past: null,
                other_domain: ''
            },
            srd_ror:{
                access: null,
                validation: false
            },
            nifs: [],
            channel: {
                known_by: ''
            }
        },
        addresses: [
            {
                address_type: AddressEnumType.postale,
                street_number: '',
                street_extension: '',
                street_name: '',
                street_name_further: '',
                city: {
                    zipcode: '',
                    name: ''
                },
                country: '',
                id: ''
            },
            {
                address_type: AddressEnumType.fiscale,
                street_number: '',
                street_extension: '',
                street_name: '',
                street_name_further: '',
                city: {
                    zipcode: '',
                    name: ''
                },
                country: '',
                id: ''
            }
        ],
        accounts: [
            {
                index: 0,
                title: '',
                type: '',
                is_transfer: null,
                id: null,
                disabled: false,
                fees: {
                    brokerage: '',
                    custody: ''
                },
                is_peaj: false
            }
        ],
        company: {
            company_id: '',
            basic : {
                name: '',
                legal_form: '',
                created_at: '',
                rcs: '',
                ape: '',
                siret: '',
            },
            vat: '',
            lei: '',
            tax_option: '',
            industry_sector: '',
            results: {
                current: {
                    revenue: null,
                    capital: null,
                    equity: null,
                    assets: null,
                    cash: null
                },
                previous: {
                    revenue: null,
                    capital: null,
                    equity: null,
                    assets: null,
                    cash: null
                }
            },
            illegal_behaviors_prevention: {
                has_other_share_account: null,
                is_listed_company: null,
                is_affiliated_with_listed_company: null,
                listed_company_name: '',
                is_regulated_entity: null
            },
            investment_expectation: '',
            derivative_products: {
                access: null,
            },
            srd_ror:{
                access: null,
            },
            investment: {
                transfer_count: '',
                invest_amount: '',
                average_transfer_amount: '',
                origin: '',
                other_origin: ''
            },
            ibans: [
                {
                    iban: '',
                    bic: '',
                    bank_name: ''
                }
            ],
            beneficial_owners: []
        },
        company_addresses: [
            {
                address_type: AddressEnumType.postale,
                street_number: '',
                street_extension: '',
                street_name: '',
                street_name_further: '',
                city: {
                    zipcode: '',
                    name: ''
                },
                country: '',
                id: ''
            },
            {
                address_type: AddressEnumType.fiscale,
                street_number: '',
                street_extension: '',
                street_name: '',
                street_name_further: '',
                city: {
                    zipcode: '',
                    name: ''
                },
                country: '',
                id: ''
            }
        ],
    },
    setField: (fieldPath: string, value: any) => set((state) => {
        const updatedState = setByPath(state.registration, fieldPath, value);
        return { registration: updatedState };
    }),
    updateAccountField: (index: number, key: string, value: any) =>
        set((state) => ({
            registration: {
                ...state.registration,
                accounts: state.registration.accounts.map((account) =>
                    account.index === index
                        ? { ...account, [key]: value }
                        : account
                ),
            },
        })),
    updateIbanField: (ibanIndex: number, key: string, value: any) =>
        set((state) => ({
            registration: {
                ...state.registration,
                company: {
                    ...state.registration.company,
                    ibans: state.registration.company.ibans.map((iban, index) =>
                        index === ibanIndex
                            ? { ...iban, [key]: value }
                            : iban
                    ),
                },
            },
        })),
}))

export default useRegistrationStore;
